/**
 * Collection products-per-page: 24 / 48 / 72 via Shopify alternate templates (?view=).
 * collection.json = 24, collection.pp48.json = 48, collection.pp72.json = 72
 */
(function () {
  function currentPp() {
    try {
      var path = window.location.pathname || '';
      // view param: ?view=pp48
      var u = new URL(window.location.href);
      var v = (u.searchParams.get('view') || '').toLowerCase();
      if (v === 'pp48' || v === '48') return '48';
      if (v === 'pp72' || v === '72') return '72';
      // sometimes Shopify appends view in path for some themes — ignore
    } catch (e) {}
    return '24';
  }

  function setPp(v) {
    try {
      var u = new URL(window.location.href);
      u.searchParams.delete('page');
      if (v === '24') {
        u.searchParams.delete('view');
      } else if (v === '48') {
        u.searchParams.set('view', 'pp48');
      } else if (v === '72') {
        u.searchParams.set('view', 'pp72');
      }
      window.location.href = u.toString();
    } catch (e) {
      window.location.search = v === '24' ? '' : 'view=pp' + v;
    }
  }

  function boot() {
    var sel = document.querySelector('[data-sfl-per-page]');
    if (!sel) return;
    sel.value = currentPp();
    sel.addEventListener('change', function () {
      setPp(sel.value);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
